module.exports = __webpack_public_path__ + "assets/img/index-product1.fc3d0eac.png";